import { roundTo } from "../../utils/mathUtils";
import { rankCol, playerCol, divCol, teamCol, confCol, yearCol, numCol, decPctCol, round1Col } from "./helpers";

const xbtPctCol = (width = "6rem") => ({
  name: "XBT%",
  selector: (row) => row.ebt_opps ? Number(row.ebt_taken / row.ebt_opps) : null,
  sortable: true,
  width,
  className: "text-center",
  cell: (row) => row.ebt_opps ? `${roundTo(Number((row.ebt_taken / row.ebt_opps) * 100), 1)}%` : "—",
});

const baserunningStats = [
  numCol("G", "games"),
  numCol("SB", "sb"),
  numCol("CS", "cs"),
  numCol("Att", "sb_att"),
  decPctCol("SB%", "sb_pct"),
  round1Col("Att/G", "sb_att_per_game"),
  numCol("SB 2B", "sb_2b"),
  numCol("CS 2B", "cs_2b"),
  numCol("Att 2B", "att_2b"),
  decPctCol("SB% 2B", "sb_2b_pct"),
  round1Col("Att/G 2B", "att_2b_per_game"),
  numCol("SB 3B", "sb_3b"),
  numCol("CS 3B", "cs_3b"),
  numCol("Att 3B", "att_3b"),
  decPctCol("SB% 3B", "sb_3b_pct"),
  round1Col("Att/G 3B", "att_3b_per_game"),
  round1Col("wSB", "wsb"),
  numCol("GDP Opp", "gdp_opps", "6rem"),
  numCol("GDP", "gdp"),
  round1Col("wGDP", "wgdp"),
  numCol("XBT", "ebt_taken"),
  numCol("XBT Opp", "ebt_opps", "6rem"),
  xbtPctCol(),
  round1Col("wXBT", "webt"),
  { ...round1Col("BsR", "baserunning"), className: "text-center font-bold" },
];

export const columnsBaserunningPlayer = [
  rankCol(), playerCol(), teamCol(), confCol(), divCol(), yearCol(),
  ...baserunningStats,
];

export const columnsBaserunningTeam = [
  rankCol(), teamCol(), confCol(), divCol(), yearCol(),
  ...baserunningStats,
];
